import { IMapWidgetAction } from "./MapWidgetAction";
import { IMapWidgetState } from "./MapWidgetContext";

export const reducer = (state: IMapWidgetState, action: IMapWidgetAction): IMapWidgetState => {

    return { ...state, ...action.payload };
    // switch (action.type) {
    //     case SurveyAction.SurveyConfirm:
    //         return { ...state, ...action.payload }
    //     default:
    //         return { ...state, ...action.payload };
    // }

}